import { useTranslation } from "react-i18next";
import NoAvailableImage from "../../assets/images/no-data-available.svg";
import * as S from "./styles";

export function NoDataAvailableImage() {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.StyledNoDataAvailableImage
        src={NoAvailableImage}
        alt={t("noAvailableDataImageAlt")}
      />

      <S.NoDataAvailableText>{t("noDataAvailable")}</S.NoDataAvailableText>
    </S.Container>
  );
}
